import { z } from 'zod';

import type { Address } from '@/models/Address.ts';
import type { Phone } from '@/models/Phone.ts';

export const ContactSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  relationship: z.string().nullish(),
  createDate: z.string(),
  lastUpdateDate: z.string(),
  note: z.string().optional().nullish(),
  fullName: z.string(),
  dateOfBirth: z.string().nullish(),
  gender: z.string().nullish(),
  email: z.string().nullish(),
  address: z.custom<Address>().nullish(),
  nino: z.string().nullish(),
  phoneNumbers: z.array(z.custom<Phone>()).nullish(),
});
export type Contact = z.infer<typeof ContactSchema>;
